import {Navigate, useLocation} from "react-router-dom";
import {ArtistBackground} from "src/components";
import {getArtistFromPath} from "src/utils/artist.utils";
import {useRouteGuard} from "../hooks/useRouteGuard";
import styles from "../styles/RouteGuard.module.scss";

type RouteGuardProps = {
  children: React.ReactNode;
  redirectTo: string;
};

const RouteGuard = ({children, redirectTo}: RouteGuardProps) => {
  const {pathname} = useLocation();
  const artist = getArtistFromPath(pathname);
  const {isLoading, accessDenied} = useRouteGuard(pathname);

  if (isLoading) {
    return (
      <div className={styles.routeGuardContainer}>
        <ArtistBackground artist={artist} />
      </div>
    );
  }

  if (accessDenied) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RouteGuard;
